import { Dispatch } from 'react';
import { InsuranceJourneyConfirmationDetailsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const ConfirmationDetailsPageEventHandlers = (
  confirmationDetails: InsuranceJourneyConfirmationDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeIAgree: (value: boolean) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: { ...confirmationDetails, iAgree: value }
      });
    },
    onChangeMarketingViaPost: (value: boolean) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: { ...confirmationDetails, marketingViaPost: value }
      });
    },
    onChangeMarketingViaEmail: (value: boolean) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          marketingViaEmail: value
        }
      });
    },
    onChangeMarketingViaPhone: (value: boolean) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          marketingViaPhone: value
        }
      });
    },
    onChangeMarketingViaTextMessage: (value: boolean) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          marketingViaTextMessage: value
        }
      });
    },
    onChangeKeepingYouInformed: (value: string) => {
      const updateMarketingPreferences = false;
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          keepingYouInformed: value,
          marketingViaEmail: updateMarketingPreferences,
          marketingViaPhone: updateMarketingPreferences,
          marketingViaPost: updateMarketingPreferences,
          marketingViaTextMessage: updateMarketingPreferences
        }
      });
    },

    onChangeNextYearInsurance: (value: string) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          nextYearInsurance: value
        }
      });
    },

    onChangeYourDocuments: (value: string) => {
      dispatch({
        type: 'set-confirmation-details',
        confirmationDetails: {
          ...confirmationDetails,
          yourDocuments: value
        }
      });
    }
  };
};
